import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Courses
export const getCourses = (params) => api.get('/courses', { params });
export const getCourse = (id) => api.get(`/courses/${id}`);
export const createCourse = (data) => api.post('/courses', data);
export const updateCourse = (id, data) => api.put(`/courses/${id}`, data);
export const publishCourse = (id) => api.post(`/courses/${id}/publish`);
export const addModule = (courseId, data) => api.post(`/courses/${courseId}/modules`, data);

// Enrollments
export const getEnrollments = () => api.get('/enrollments');
export const enrollInCourse = (courseId, options = {}) => api.post('/enrollments', { 
  course_id: courseId,
  tier_type: options.tier_type || 'instructor_led',
  coupon_code: options.coupon_code || null
});
export const updateProgress = (enrollmentId, videoId) => 
  api.post(`/enrollments/${enrollmentId}/progress?video_id=${videoId}`);

// Coupons
export const validateCoupon = (code, courseId, tierType, price) => 
  api.post('/coupons/validate', { code, course_id: courseId, tier_type: tierType, price });
export const getAdminCoupons = () => api.get('/admin/coupons');
export const createCoupon = (data) => api.post('/admin/coupons', data);
export const updateCoupon = (id, data) => api.put(`/admin/coupons/${id}`, data);
export const deleteCoupon = (id) => api.delete(`/admin/coupons/${id}`);

// Assignments
export const getAssignments = (courseId) => api.get('/assignments', { params: { course_id: courseId } });
export const createAssignment = (data) => api.post('/assignments', data);
export const getSubmissions = (assignmentId) => api.get('/submissions', { params: { assignment_id: assignmentId } });
export const submitAssignment = (data) => api.post('/submissions', data);
export const gradeSubmission = (id, score, feedback) => 
  api.put(`/submissions/${id}/grade?score=${score}&feedback=${encodeURIComponent(feedback)}`);

// Exams
export const getExams = (courseId) => api.get('/exams', { params: { course_id: courseId } });
export const getExam = (id) => api.get(`/exams/${id}`);
export const createExam = (data) => api.post('/exams', data);
export const submitExam = (examId, answers) => api.post(`/exams/${examId}/submit`, { exam_id: examId, answers });

// Chat
export const getChatMessages = (params) => api.get('/chat/messages', { params });
export const sendChatMessage = (data) => api.post('/chat/messages', data);

// AI Tutor
export const askAITutor = (question, courseContext) => 
  api.post('/ai/tutor', { question, course_context: courseContext });

// Admin
export const getAdminDashboard = () => api.get('/admin/dashboard');
export const getAllUsers = (role) => api.get('/admin/users', { params: { role } });
export const updateUserRole = (userId, role) => api.put(`/admin/users/${userId}/role?role=${role}`);

// Alumni
export const getAlumni = (featuredOnly = false) => api.get('/alumni', { params: { featured_only: featuredOnly } });
export const getAdminAlumni = () => api.get('/admin/alumni');
export const createAlumni = (data) => api.post('/admin/alumni', data);
export const updateAlumni = (id, data) => api.put(`/admin/alumni/${id}`, data);
export const deleteAlumni = (id) => api.delete(`/admin/alumni/${id}`);

// Admin User Management
export const deleteMentor = (userId) => api.delete(`/admin/mentors/${userId}`);
export const deleteStudent = (userId) => api.delete(`/admin/students/${userId}`);

// Gamification
export const getLeaderboard = () => api.get('/leaderboard');
export const getBadges = () => api.get('/badges');

// Payments
export const getPaymentConfig = () => api.get('/payments/config');
export const createPaymentOrder = (data) => api.post('/payments/create-order', data);
export const verifyPayment = (data) => api.post('/payments/verify', data);
export const getPaymentHistory = () => api.get('/payments/history');
export const getUserSubscriptions = () => api.get('/payments/subscriptions');
export const cancelSubscription = (subscriptionId) => api.post(`/payments/subscriptions/${subscriptionId}/cancel`);

export default api;
